import ExcelJS from "exceljs"

export const applicationsForGroup = group => Array.isArray(group.latestApplications)
  ? group.latestApplications.filter(Boolean) : group.latestApplication ? [group.latestApplication] : []
const field = (key, header, type = "text") => ({ key, header, type, value: row => key.split(".").reduce((value, part) => value?.[part], row) })
export const groupFields = [
  field("groupName", "Group name"), field("groupId", "Group ID"),
  field("orgCode", "Organization code"), field("orgId", "Organization ID"),
  field("description", "Description"), field("icon", "Icon"), field("serial", "Display order", "number"),
  field("deployStatus", "Deployment status"), field("deployStgy", "Deployment strategy"),
  field("settlementStng", "Settlement setting"), field("clearAppStatus", "Clear app status", "boolean"),
  field("groupSummaryDtl.totTerminals", "Total terminals", "number"),
  field("groupSummaryDtl.activeTerminals", "Active terminals", "number"),
  { key: "assignedApps", header: "Assigned applications", type: "number", value: row => applicationsForGroup(row).length },
  field("createDateTime", "Created"), field("updatedDateTime", "Last updated"), field("updatedOnDateTime", "Updated on"),
]
export const applicationFields = [
  field("groupId", "Group ID"), field("groupName", "Group name"), field("orgCode", "Organization code"),
  field("grpId", "Application group ID"), field("applicationId", "Application ID"),
  field("appName", "Application name"), field("appId", "Package ID"), field("appVersion", "Version"),
  field("versionCode", "Version code", "number"), field("totInstallCount", "Install count", "number"),
  field("assignedAt", "Assigned at"),
]
export const groupApplicationRows = groups => groups.flatMap(group => applicationsForGroup(group).map(app => ({
  ...app, groupId: group.groupId, groupName: group.groupName, orgCode: group.orgCode,
})))

export function buildGroupReportWorkbook(groups) {
  const workbook = new ExcelJS.Workbook()
  workbook.creator = "AIKEN TOMS"
  workbook.created = new Date()
  for (const [name, fields, rows] of [["Groups", groupFields, groups], ["Group applications", applicationFields, groupApplicationRows(groups)]]) {
    const sheet = workbook.addWorksheet(name, { views: [{ state: "frozen", ySplit: 1 }] })
    sheet.columns = fields.map(field => ({ header: field.header, key: field.key,
      width: /name|description|Package/.test(field.header) ? 48 : /Created|updated|Updated|Assigned at/.test(field.header) ? 27 : 22 }))
    rows.forEach(item => sheet.addRow(fields.map(field => {
      const value = field.value(item)
      if (value == null) return null
      if (field.type === "boolean") return value ? "Yes" : "No"
      return field.type === "number" ? value : String(value)
    })))
    sheet.autoFilter = { from: { row: 1, column: 1 }, to: { row: 1, column: fields.length } }
    sheet.getRow(1).height = 32
    sheet.eachRow((row, index) => {
      row.alignment = { vertical: "top", wrapText: true }
      if (index === 1) {
        row.font = { bold: true, color: { argb: "FFFFFFFF" } }
        row.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF126D71" } }
      } else if (index % 2 === 0) {
        row.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF1F6F6" } }
      }
    })
  }
  return workbook
}
